import { render, staticRenderFns } from "./CalculoList.vue?vue&type=template&id=081d172b"
import script from "./CalculoList.vue?vue&type=script&lang=js"
export * from "./CalculoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports